import { Typography, TypographyProps } from '@automata/ui';
import React from 'react';

export type Props = TypographyProps & {};

export const FormSectionLabel = ({
  children,
  ...props
}: Props): JSX.Element => (
  <Typography variant="h4" {...props}>
    {children}
  </Typography>
);
